/**
 * Spinner wrapper element class name.
 *
 * @type {string}
 */
export const WRAPPER_CLASSNAME = 'llms-spinning';

/**
 * Spinner element class name.
 *
 * @type {string}
 */
export const CLASSNAME = 'llms-spinner';

/**
 * Small-sized spinner identifier / class name.
 *
 * @type {string}
 */
export const SIZE_SMALL = 'small';

/**
 * Default-sized spinner identifier / class name.
 *
 * @type {string}
 */
export const SIZE_DEFAULT = 'default';
